<div canvas-container>
  <div #canvasBox image>
    <canvas #canvasImage
            (click)="clickCanvas($event)"
            (mousemove)="mouseMoveCanvas($event)"
            (wheel)="wheelCanvas($event)"></canvas>
  </div>
  <div edge tl>
    <button (click)="clickSelectTrigger('tl')" [style]="selectColor(data.mixColors.tl)" color-select></button>
  </div>
  <div edge tr>
    <button (click)="clickSelectTrigger('tr')" [style]="selectColor(data.mixColors.tr)" color-select></button>
  </div>
  <div bl edge>
    <button (click)="clickSelectTrigger('bl')" [style]="selectColor(data.mixColors.bl)" color-select></button>
  </div>
  <div br edge>
    <button (click)="clickSelectTrigger('br')" [style]="selectColor(data.mixColors.br)" color-select></button>
  </div>

  <div [style]="styleForColorWheel" color-wheel>
    <ng-container *ngFor="let color of wheelColorList; let idx = index">
      <button (click)="clickColorSelect(color)" [style]="selectColorWheel(idx)" color></button>
    </ng-container>
  </div>
</div>
